import { getStore } from '~/mobx/AppStore';

const getUserEmail = () => {
    const { userStore } = getStore();
    return userStore.user?.email || '';
};

export default getUserEmail;
